export default function getEthereum() {
  return (window as any).ethereum
}